import React from 'react';
import ANoticeBar from 'antd-mobile/lib/notice-bar';



export default class NoticeBar extends ANoticeBar {}